import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "clientId", "omitFocusRing", "focusRingOptions", "isDisabled", "onClick", "onDoubleClick", "tabIndex", "type"];
import React, { forwardRef, useCallback, useMemo } from "react";
import { getFocusRingStyles } from "../../util/focusRing";
import { ClickableStyled } from "./styled/ClickableStyled";
/**
 * Provides the basic stuff for any clickables, include a style reset!
 */
export var Clickable = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    clientId = _ref.clientId,
    _ref$omitFocusRing = _ref.omitFocusRing,
    omitFocusRing = _ref$omitFocusRing === void 0 ? false : _ref$omitFocusRing,
    _ref$focusRingOptions = _ref.focusRingOptions,
    focusRingOptions = _ref$focusRingOptions === void 0 ? {} : _ref$focusRingOptions,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    providedOnClick = _ref.onClick,
    providedOnDoubleClick = _ref.onDoubleClick,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  var onDoubleClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  var focusRingStyles = useMemo(function () {
    return omitFocusRing ? "" : getFocusRingStyles(_objectSpread({
      theme: "light",
      offset: 4,
      radius: 4,
      includeFocusPseudoClass: true
    }, focusRingOptions));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [omitFocusRing].concat(_toConsumableArray(Object.values(focusRingOptions))));
  return /*#__PURE__*/React.createElement(ClickableStyled, _extends({}, rest, {
    isDisabled: isDisabled,
    "aria-disabled": isDisabled,
    "data-client-id": clientId,
    focusRingStyles: focusRingStyles,
    ref: ref,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    tabIndex: tabIndex,
    type: type
  }), children);
});
Clickable.displayName = "Clickable";
//# sourceMappingURL=Clickable.js.map